import _typeof from '@babel/runtime/helpers/esm/typeof';
import React from 'react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { keyframes } from '@emotion/react';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';

var INPUT_TYPES = {
  date: 'datetime',
  single_choice: 'singleChoice',
  multi_choice: 'multiChoice',
  free_input: 'freeInput',
  dropdown: 'dropDown',
  zip_code: 'zipcode',
  text_input: 'text',
  currency: 'currency',
  eMail: 'email',
  phone: 'phone',
  integer: 'integer',
  address: 'address'
};
var PROFILE_FIELDS_KEYS = {
  privacy_terms_approved: 'privacy_terms_approved',
  tcpa: 'tcpa',
  tcpa_optinDate: 'tcpa_optinDate',
  dob: 'date_of_birth',
  firstName: 'first_name',
  lastName: 'last_name',
  email: 'email',
  ssn: 'ssn',
  currency: 'currency',
  primaryPhone: 'primary_phone',
  annualIncome: 'annual_income'
};
var CONSENT_PROFILE_FIELDS = [PROFILE_FIELDS_KEYS.privacy_terms_approved, PROFILE_FIELDS_KEYS.tcpa, PROFILE_FIELDS_KEYS.tcpa_optinDate];
var statesList = [{
  displayValue: 'Alabama',
  value: 'AL'
}, {
  displayValue: 'Alaska',
  value: 'AK'
}, {
  displayValue: 'Arizona',
  value: 'AZ'
}, {
  displayValue: 'Arkansas',
  value: 'AR'
}, {
  displayValue: 'California',
  value: 'CA'
}, {
  displayValue: 'Colorado',
  value: 'CO'
}, {
  displayValue: 'Connecticut',
  value: 'CT'
}, {
  displayValue: 'Delaware',
  value: 'DE'
}, {
  displayValue: 'Florida',
  value: 'FL'
}, {
  displayValue: 'Georgia',
  value: 'GA'
}, {
  displayValue: 'Hawaii',
  value: 'HI'
}, {
  displayValue: 'Idaho',
  value: 'ID'
}, {
  displayValue: 'Illinois',
  value: 'IL'
}, {
  displayValue: 'Indiana',
  value: 'IN'
}, {
  displayValue: 'Iowa',
  value: 'IA'
}, {
  displayValue: 'Kansas',
  value: 'KS'
}, {
  displayValue: 'Kentucky',
  value: 'KY'
}, {
  displayValue: 'Louisiana',
  value: 'LA'
}, {
  displayValue: 'Maine',
  value: 'ME'
}, {
  displayValue: 'Maryland',
  value: 'MD'
}, {
  displayValue: 'Massachusetts',
  value: 'MA'
}, {
  displayValue: 'Michigan',
  value: 'MI'
}, {
  displayValue: 'Minnesota',
  value: 'MN'
}, {
  displayValue: 'Mississippi',
  value: 'MS'
}, {
  displayValue: 'Missouri',
  value: 'MO'
}, {
  displayValue: 'Montana',
  value: 'MT'
}, {
  displayValue: 'Nebraska',
  value: 'NE'
}, {
  displayValue: 'Nevada',
  value: 'NV'
}, {
  displayValue: 'New Hampshire',
  value: 'NH'
}, {
  displayValue: 'New Jersey',
  value: 'NJ'
}, {
  displayValue: 'New Mexico',
  value: 'NM'
}, {
  displayValue: 'New York',
  value: 'NY'
}, {
  displayValue: 'North Carolina',
  value: 'NC'
}, {
  displayValue: 'North Dakota',
  value: 'ND'
}, {
  displayValue: 'Ohio',
  value: 'OH'
}, {
  displayValue: 'Oklahoma',
  value: 'OK'
}, {
  displayValue: 'Oregon',
  value: 'OR'
}, {
  displayValue: 'Pennsylvania',
  value: 'PA'
}, {
  displayValue: 'Puerto Rico',
  value: 'PR'
}, {
  displayValue: 'Rhode Island',
  value: 'RI'
}, {
  displayValue: 'South Carolina',
  value: 'SC'
}, {
  displayValue: 'South Dakota',
  value: 'SD'
}, {
  displayValue: 'Tennessee',
  value: 'TN'
}, {
  displayValue: 'Texas',
  value: 'TX'
}, {
  displayValue: 'Utah',
  value: 'UT'
}, {
  displayValue: 'Vermont',
  value: 'VT'
}, {
  displayValue: 'Virginia',
  value: 'VA'
}, {
  displayValue: 'Virgin Islands',
  value: 'VI'
}, {
  displayValue: 'Washington DC',
  value: 'DC'
}, {
  displayValue: 'Washington WA',
  value: 'WA'
}, {
  displayValue: 'West Virginia',
  value: 'WV'
}, {
  displayValue: 'Wisconsin',
  value: 'WI'
}, {
  displayValue: 'Wyoming',
  value: 'WY'
}];

var dataPixel = {
  home_improvement: {
    pixelIndex: 1,
    dataKey: 'LP'
  },
  large_purchases: {
    pixelIndex: 2,
    dataKey: 'LP'
  },
  credit_card_refi: {
    pixelIndex: 3,
    dataKey: 'LP'
  },
  debt_consolidation: {
    pixelIndex: 4,
    dataKey: 'LP'
  },
  special_occasion: {
    pixelIndex: 5,
    dataKey: 'LP'
  },
  medical_dental: {
    pixelIndex: 6,
    dataKey: 'LP'
  },
  student_loan: {
    pixelIndex: 8,
    dataKey: 'LP'
  },
  boat: {
    pixelIndex: 9,
    dataKey: 'LP'
  },
  auto_purchase: {
    pixelIndex: 10,
    dataKey: 'LP'
  },
  student_loan_refi: {
    pixelIndex: 11,
    dataKey: 'LP'
  },
  baby: {
    pixelIndex: 12,
    dataKey: 'LP'
  },
  household_expenses: {
    pixelIndex: 13,
    dataKey: 'LP'
  },
  business: {
    pixelIndex: 14,
    dataKey: 'LP'
  },
  green: {
    pixelIndex: 15,
    dataKey: 'LP'
  },
  moving_relocation: {
    pixelIndex: 16,
    dataKey: 'LP'
  },
  car_repair: {
    pixelIndex: 17,
    dataKey: 'LP'
  },
  taxes: {
    pixelIndex: 18,
    dataKey: 'LP'
  },
  vacation: {
    pixelIndex: 19,
    dataKey: 'LP'
  },
  rv: {
    pixelIndex: 20,
    dataKey: 'LP'
  },
  emergency: {
    pixelIndex: 21,
    dataKey: 'LP'
  },
  motorcycle: {
    pixelIndex: 22,
    dataKey: 'LP'
  },
  cosmetic: {
    pixelIndex: 23,
    dataKey: 'LP'
  },
  wedding: {
    pixelIndex: 24,
    dataKey: 'LP'
  },
  home_refi: {
    pixelIndex: 25,
    dataKey: 'LP'
  },
  engagement: {
    pixelIndex: 26,
    dataKey: 'LP'
  },
  home_purchase: {
    pixelIndex: 27,
    dataKey: 'LP'
  },
  excellent: {
    pixelIndex: 4,
    isBold: true,
    dataKey: 'CS'
  },
  good: {
    pixelIndex: 3,
    isBold: true,
    dataKey: 'CS'
  },
  fair: {
    pixelIndex: 2,
    isBold: true,
    dataKey: 'CS'
  },
  poor: {
    pixelIndex: 1,
    isBold: true,
    dataKey: 'CS'
  },
  rent: {
    pixelIndex: 1,
    dataKey: 'RO'
  },
  own_outright: {
    pixelIndex: 2,
    dataKey: 'RO'
  },
  own_with_mortgage: {
    pixelIndex: 3,
    dataKey: 'RO'
  },
  unknown: {
    pixelIndex: 4,
    dataKey: 'RO'
  },
  employed_full_time: {
    pixelIndex: 1,
    dataKey: 'ES'
  },
  employed_part_time: {
    pixelIndex: 2,
    dataKey: 'ES'
  },
  self_employed: {
    pixelIndex: 3,
    dataKey: 'ES'
  },
  retired: {
    pixelIndex: 4,
    dataKey: 'ES'
  },
  not_employed: {
    pixelIndex: 5,
    dataKey: 'ES'
  },
  military: {
    pixelIndex: 6,
    dataKey: 'ES'
  },
  weekly: {
    pixelIndex: 1,
    dataKey: 'PF'
  },
  biweekly: {
    pixelIndex: 2,
    dataKey: 'PF'
  },
  monthly: {
    pixelIndex: 3,
    dataKey: 'PF'
  },
  twice_monthly: {
    pixelIndex: 4,
    dataKey: 'PF'
  },
  high_school: {
    pixelIndex: 1,
    dataKey: 'EL'
  },
  associate: {
    pixelIndex: 2,
    dataKey: 'EL'
  },
  bachelors: {
    pixelIndex: 3,
    dataKey: 'EL'
  },
  masters: {
    pixelIndex: 4,
    dataKey: 'EL'
  },
  doctorate: {
    pixelIndex: 5,
    dataKey: 'EL'
  },
  other_grad_degree: {
    pixelIndex: 6,
    dataKey: 'EL'
  }
};
var pixelKeys = {
  loan_amount: {
    key: 'LA',
    ranges: [{
      min: 1,
      max: 499
    }, {
      min: 500,
      max: 999
    }, {
      min: 1000,
      max: 1499
    }, {
      min: 1500,
      max: 1999
    }, {
      min: 2000,
      max: 2499
    }, {
      min: 2500,
      max: 2999
    }, {
      min: 3000,
      max: 3499
    }, {
      min: 3500,
      max: 3999
    }, {
      min: 4000,
      max: 4499
    }, {
      min: 4500,
      max: 4999
    }, {
      min: 5000,
      max: 5999
    }, {
      min: 6000,
      max: 6999
    }, {
      min: 7000,
      max: 7999
    }, {
      min: 8000,
      max: 8999
    }, {
      min: 9000,
      max: 9999
    }, {
      min: 10000,
      max: 10999
    }, {
      min: 11000,
      max: 11999
    }, {
      min: 12000,
      max: 12999
    }, {
      min: 13000,
      max: 13999
    }, {
      min: 14000,
      max: 14999
    }, {
      min: 15000,
      max: 15999
    }, {
      min: 16000,
      max: 16999
    }, {
      min: 17000,
      max: 17999
    }, {
      min: 18000,
      max: 18999
    }, {
      min: 19000,
      max: 19999
    }, {
      min: 20000,
      max: 24999
    }, {
      min: 25000,
      max: 29999
    }, {
      min: 30000,
      max: 34999
    }, {
      min: 35000,
      max: 39999
    }, {
      min: 40000,
      max: 44999
    }, {
      min: 45000,
      max: 49999
    }, {
      min: 50000,
      max: 54999
    }, {
      min: 55000,
      max: 99999
    }, {
      min: 100000,
      max: 1000000000
    }]
  },
  annual_income: {
    key: 'AI',
    ranges: [{
      min: 1,
      max: 999
    }, {
      min: 1000,
      max: 9999
    }, {
      min: 10000,
      max: 11999
    }, {
      min: 12000,
      max: 19999
    }, {
      min: 20000,
      max: 29999
    }, {
      min: 30000,
      max: 39999
    }, {
      min: 40000,
      max: 49999
    }, {
      min: 50000,
      max: 59999
    }, {
      min: 60000,
      max: 69999
    }, {
      min: 70000,
      max: 79999
    }, {
      min: 80000,
      max: 89999
    }, {
      min: 90000,
      max: 99999
    }, {
      min: 100000,
      max: 109999
    }, {
      min: 110000,
      max: 119999
    }, {
      min: 120000,
      max: 129999
    }, {
      min: 130000,
      max: 189999
    }, {
      min: 190000,
      max: 10000000000
    }]
  },
  address: {
    key: 'AD',
    value: '1'
  },
  fullAddress: {
    key: 'AD',
    value: '1'
  },
  full_address: {
    key: 'AD',
    value: '1'
  },
  property_address: {
    key: 'PA',
    value: '1'
  },
  primary_phone: {
    key: 'PN',
    value: '1'
  },
  fullName: {
    key: 'NM',
    value: '1'
  },
  full_name: {
    key: 'NM',
    value: '1'
  },
  ssn: {
    key: 'SS',
    value: '1'
  },
  signup: {
    key: 'EM',
    value: '1'
  },
  email: {
    key: 'EM',
    value: '1'
  },
  loan_purpose: {
    key: 'LP',
    value: {
      home_improvement: '3',
      large_purchases: '4',
      credit_card_refi: '2',
      debt_consolidation: '1',
      special_occasion: '8',
      medical_dental: '7',
      student_loan: '8',
      boat: '17',
      auto_purchase: '11',
      student_loan_refi: '14',
      baby: '18',
      household_expenses: '6',
      business: '10',
      green: '26',
      moving_relocation: '13',
      car_repair: '12',
      taxes: '9',
      vacation: '15',
      rv: '19',
      emergency: '5',
      motorcycle: '20',
      cosmetic: '21',
      wedding: '22',
      home_refi: '23',
      engagement: '24',
      home_purchase: '25'
    }
  },
  property_type: {
    key: 'PT',
    value: {
      single_family_home: '1',
      townhouse: '3',
      apartment_duplex: '2',
      cooperative: '6',
      condo_4_or_fewer_stories: '5',
      'condo_5+_stories': '5',
      mobile_or_manufactured: '4'
    }
  },
  property_use: {
    key: 'PU',
    value: {
      primary_residence: '1',
      vacation_home: '2',
      seasonal_residence: '3',
      tenant_occupied: '4'
    }
  },
  bedrooms_number: {
    key: 'BN'
  },
  bathrooms_number: {
    key: 'BTN'
  },
  roof_type: {
    key: 'RT',
    value: {
      asphalt_shingle: '1',
      wood_shingle: '2',
      tile_shingle: '3',
      metal_roof: '4',
      other_not_sure: '5'
    }
  },
  property_year: {
    key: 'PY',
    value: {
      2020: '1',
      2010: '2',
      2000: '3',
      1990: '4',
      1980: '5',
      1970: '6',
      1960: '7',
      1950: '8',
      1940: '9',
      1930: '10',
      1920: '11',
      1910: '12',
      1900: '13',
      before_1900: '14'
    }
  },
  square_footage: {
    key: 'SF',
    value: {
      '500_or_less': '1',
      '501_1000': '2',
      '1001_1500': '3',
      '1501_2000': '4',
      '2001_2500': '5',
      '2501_3000': '6',
      '3001_3500': '7',
      '3501_4000': '8',
      '4001_4500': '9',
      '4501_5000': '10',
      '5000+': '11'
    }
  },
  property_state: {
    key: 'PL'
  },
  property_value: {
    key: 'HV'
  },
  found_new_home: {
    key: 'FH',
    value: {
      "true": 'Y',
      "false": 'N'
    }
  },
  have_real_estate_agent: {
    key: 'RE',
    value: {
      "true": 'Y',
      "false": 'N'
    }
  },
  gender: {
    key: 'GN',
    value: {
      male: '1',
      female: '2',
      other: '3'
    }
  },
  driver_has_ticket_claims: {
    key: 'IC',
    value: {
      "true": '1',
      "false": '2'
    }
  },
  new_home_status: {
    // TODO: make sure this is the meaning for the value and question interpretations
    key: 'IT',
    value: {
      under_contract: 'super',
      immediate_offer: 'high',
      in_consideration: 'medium',
      in_several_months: 'low'
    }
  },
  down_payment: {
    key: 'RE'
  },
  first_time_buyer: {
    key: 'FT',
    value: {
      "true": 'Y',
      "false": 'N'
    }
  },
  co_borrower: {
    key: 'CB',
    value: {
      "true": 'Y',
      "false": 'N'
    }
  },
  veteran: {
    key: 'MS',
    value: {
      "true": 'Y',
      "false": 'N'
    }
  },
  bankruptcy_or_foreclosure: {
    key: 'BR',
    value: {
      no: 'no',
      bankruptcy: 'bankruptcy',
      foreclosure: 'foreclosure',
      both: 'both'
    }
  },
  bankruptcy_time: {
    key: 'IB'
  },
  employment_status: {
    key: 'ES',
    value: {
      employed_full_time: 'full',
      employed_part_time: 'part',
      military: 'military',
      not_employed: 'not',
      self_employed: 'self',
      retired: 'retired',
      other: 'other',
      unknown: 'unknown'
    }
  },
  refi_reason: {
    key: 'RR',
    value: {
      lower_monthly_payment: 'lower pay',
      faster_mortgage_payment: 'ShortenLoan',
      take_cash_out_of_home: 'cashout',
      change_ARM_loan_to_fixed: 'change rate',
      browse_mortgage_rate: 'browse rates'
    }
  },
  property_zip_code: {
    key: 'ZC'
  },
  zip_code: {
    key: 'ZC'
  },
  current_mortgage_balance: {
    key: 'CM'
  },
  interest_rate: {
    key: 'MR'
  },
  second_mortgage: {
    key: 'SM',
    value: {
      "true": 'Y',
      "false": 'N'
    }
  },
  second_mortgage_balance: {
    key: 'SB'
  },
  cashout_amount: {
    key: 'CA'
  },
  foreclosure_time: {
    key: 'IF'
  },
  vehicle_make: {
    key: 'VMK'
  },
  vehicle_year: {
    key: 'VY'
  },
  vehicle_model: {
    key: 'VMD'
  },
  vehicle_primary_use: {
    key: 'VPU'
  },
  vehicle_annual_mileage: {
    key: 'VAM'
  },
  insurance_coverage_level: {
    key: 'CL'
  },
  vehicle_ownership: {
    key: 'VOW'
  },
  add_vehicle: {
    key: 'AV'
  },
  current_insurance_carrier: {
    key: 'CI'
  },
  is_driver_license_active: {
    key: 'AL'
  },
  homeOwner: {
    key: 'HO'
  },
  education_level: {
    key: 'EL'
  },
  date_of_birth: {
    key: 'DOB',
    value: '1'
  },
  first_name: {
    key: 'NM',
    value: '1'
  },
  current_insurance_start_time: {
    key: 'CIAT',
    value: '1'
  },
  interested_in_home_insurance: {
    key: 'IHI'
  },
  provided_credit_rating: {
    key: 'CS',
    value: {
      poor: '1',
      fair: '2',
      good: '3',
      excellent: '4'
    }
  }
};

var getRangeIndex = function getRangeIndex(ranges, value) {
  return ranges.findIndex(function (_ref) {
    var min = _ref.min,
        max = _ref.max;
    return value >= min && value <= max;
  }) + 1;
};

var getPixelLabelJSON = function getPixelLabelJSON(profileKey, profileValue) {
  if (Object.keys(dataPixel).includes(profileKey) && profileValue) {
    var answerPixel = dataPixel[profileValue];

    if (answerPixel !== null && answerPixel !== void 0 && answerPixel.dataKey) {
      return JSON.stringify({
        eventName: 'trackCustom',
        data: {
          'data key': answerPixel.dataKey,
          'data value': answerPixel.pixelIndex || ''
        }
      });
    }
  }

  if (pixelKeys[profileKey]) {
    var _pixelKeys$profileKey = pixelKeys[profileKey],
        dataKey = _pixelKeys$profileKey.key,
        ranges = _pixelKeys$profileKey.ranges,
        _pixelKeys$profileKey2 = _pixelKeys$profileKey.value,
        pixelValue = _pixelKeys$profileKey2 === void 0 ? profileValue : _pixelKeys$profileKey2;
    var dataValue = _typeof(pixelValue) === 'object' ? pixelValue[profileValue] : pixelValue;

    if (ranges) {
      dataValue = getRangeIndex(ranges, profileValue);
    }

    return JSON.stringify({
      eventName: 'trackCustom',
      data: {
        'data key': dataKey,
        'data value': dataValue
      }
    });
  }

  return '';
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var StoriesWrapper = function StoriesWrapper(_ref) {
  var children = _ref.children,
      customStyle = _ref.customStyle;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: _objectSpread2({
      maxWidth: '344px',
      width: '344px'
    }, customStyle)
  }, children));
};

var _templateObject, _templateObject2;

var minDesktopWidth = '800px';
var minMediumMobileWidth = '375px';
var minSmallMobileWidth = '320px'; // Colors

var black = '#171717';
var grey = '#e3e3e2';
var darkGrey = '#a4b3ae';
var warningRed = '#ff4a64';
var mainGreen = '#16ca92';
var darkGreen = '#225447';
var greyscale4 = '#93a1a8';
var linkBlue = '#1564bf';
var dropdownHover = '#d6d6d6';
var sectionGrey = '#f3f7fc';
var sectionYellow = '#ffecb4'; // Animations

var FadeIn = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n      opacity: 0;\n  }  \n  to {\n      opacity: 1;\n  }\n"])));
var FadeInBackwards = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0%    {\n      opacity: 0;\n      transform: translateY(10vh);\n  }\n  100%  {\n      opacity: 1;\n      transform: translateY(0);\n  }\n"])));

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

// removes the 'common_' from the common_["data"] entries in gql
var getRestructuredCommonData = function getRestructuredCommonData(commonData) {
  var restructuredCommonData = commonData.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return [key.split('_')[1], value];
  });
  return Object.fromEntries(restructuredCommonData);
};

var roundUpOrDown = function roundUpOrDown(rank) {
  return Math.round(rank * 2) / 2;
};

var mapProductForGql = function mapProductForGql(products, resolvedProducts) {
  var mappedProducts = {};

  var _iterator = _createForOfIteratorHelper(products),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var element = _step.value;
      mappedProducts[element.productId] = element;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(resolvedProducts),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _element = _step2.value;
      mappedProducts[_element.id] = _objectSpread2(_objectSpread2({}, _element), mappedProducts[_element.id]);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return mappedProducts;
};

var getNormalizedProductsForGql = function getNormalizedProductsForGql(mappedProducts) {
  var rawProducts = Object.values(mappedProducts);
  return rawProducts.map(function (product) {
    var _trustpilotReviews$sp;

    var id = product.id,
        displayName = product.displayName,
        trustpilotReviews = product.trustpilotReviews,
        _product$productLogo = product.productLogo,
        url = _product$productLogo.url,
        alt = _product$productLogo.alt;
    var usedForTrustScoreCalculation = (trustpilotReviews === null || trustpilotReviews === void 0 ? void 0 : (_trustpilotReviews$sp = trustpilotReviews.splitReviews) === null || _trustpilotReviews$sp === void 0 ? void 0 : _trustpilotReviews$sp.usedForTrustScoreCalculation) || 0;
    var stars = (trustpilotReviews === null || trustpilotReviews === void 0 ? void 0 : trustpilotReviews.stars) || 0;
    return {
      id: id,
      displayName: displayName,
      productLogo: {
        url: url,
        alt: alt
      },
      engagementScore: {
        trustpilotReviewsCount: usedForTrustScoreCalculation,
        trustpilotScore: roundUpOrDown(stars)
      }
    };
  });
};

var normalizeTpProducts = function normalizeTpProducts(products, resolvedProducts) {
  if ((resolvedProducts === null || resolvedProducts === void 0 ? void 0 : resolvedProducts.length) > 0) {
    return getNormalizedProductsForGql(mapProductForGql(products, resolvedProducts));
  }

  return {};
};

var normalizeTrustpilotSection = function normalizeTrustpilotSection(trustpilotAppEntity) {
  if (!trustpilotAppEntity) {
    return null;
  }

  var _ref3 = trustpilotAppEntity !== null && trustpilotAppEntity !== void 0 ? trustpilotAppEntity : {},
      tpTitle = _ref3.title,
      tpSubtitle = _ref3.subTitle,
      maxProductsToDisplay = _ref3.maxProductsToDisplay,
      products = _ref3.products,
      _ref3$resolvedProduct = _ref3.resolvedProducts,
      resolvedProducts = _ref3$resolvedProduct === void 0 ? [] : _ref3$resolvedProduct,
      _ref3$showStars = _ref3.showStars,
      showStars = _ref3$showStars === void 0 ? true : _ref3$showStars,
      _ref3$showReviews = _ref3.showReviews,
      showReviews = _ref3$showReviews === void 0 ? true : _ref3$showReviews;

  return {
    title: tpTitle,
    subTitle: tpSubtitle,
    products: normalizeTpProducts(products, resolvedProducts),
    maxProductsToDisplay: maxProductsToDisplay,
    showStars: showStars,
    showReviews: showReviews
  };
};

var transformData = function transformData(data) {
  var _applicationEntitiesD, _applicationEntitiesD2, _applicationEntitiesD3, _applicationEntitiesD4, _applicationEntitiesD5, _applicationEntitiesD6, _applicationEntitiesD7, _applicationEntitiesD8;

  var commonEntries = Object.entries(data).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return key.startsWith('common_');
  });

  if (!commonEntries || commonEntries.length === 0) {
    return data;
  }

  var commonData = getRestructuredCommonData(commonEntries);
  var pageData = data === null || data === void 0 ? void 0 : data.pageData;
  var userProfile = data === null || data === void 0 ? void 0 : data.userProfile;
  var applicationEntitiesData = data.contextEntities;
  var standAloneQuestionnaire = applicationEntitiesData === null || applicationEntitiesData === void 0 ? void 0 : (_applicationEntitiesD = applicationEntitiesData.standAloneQuestionnaire) === null || _applicationEntitiesD === void 0 ? void 0 : _applicationEntitiesD[0];
  var siteLogoVariant = applicationEntitiesData === null || applicationEntitiesData === void 0 ? void 0 : (_applicationEntitiesD2 = applicationEntitiesData.siteLogoVariant) === null || _applicationEntitiesD2 === void 0 ? void 0 : _applicationEntitiesD2[0];
  var leadgenHeader = applicationEntitiesData === null || applicationEntitiesData === void 0 ? void 0 : (_applicationEntitiesD3 = applicationEntitiesData.leadgenHeader) === null || _applicationEntitiesD3 === void 0 ? void 0 : _applicationEntitiesD3[0];
  var trustpilotBrandsStrip = normalizeTrustpilotSection(applicationEntitiesData === null || applicationEntitiesData === void 0 ? void 0 : (_applicationEntitiesD4 = applicationEntitiesData.trustpilotBrandsStrip) === null || _applicationEntitiesD4 === void 0 ? void 0 : _applicationEntitiesD4[0]);
  var stampa = applicationEntitiesData === null || applicationEntitiesData === void 0 ? void 0 : (_applicationEntitiesD5 = applicationEntitiesData.stampa) === null || _applicationEntitiesD5 === void 0 ? void 0 : _applicationEntitiesD5[0];
  var howItWorks = applicationEntitiesData === null || applicationEntitiesData === void 0 ? void 0 : (_applicationEntitiesD6 = applicationEntitiesData.howItWorks) === null || _applicationEntitiesD6 === void 0 ? void 0 : _applicationEntitiesD6[0];
  var footerEntity = applicationEntitiesData === null || applicationEntitiesData === void 0 ? void 0 : (_applicationEntitiesD7 = applicationEntitiesData.footerEntity) === null || _applicationEntitiesD7 === void 0 ? void 0 : _applicationEntitiesD7[0];
  var ivr = applicationEntitiesData === null || applicationEntitiesData === void 0 ? void 0 : (_applicationEntitiesD8 = applicationEntitiesData.ivr) === null || _applicationEntitiesD8 === void 0 ? void 0 : _applicationEntitiesD8[0];
  return _objectSpread2(_objectSpread2({}, data), {}, {
    common: commonData,
    userProfile: userProfile,
    page: _objectSpread2(_objectSpread2({}, applicationEntitiesData), {}, {
      pageData: pageData,
      standAloneQuestionnaire: standAloneQuestionnaire,
      siteLogoVariant: siteLogoVariant,
      trustpilotBrandsStrip: trustpilotBrandsStrip,
      stampa: stampa,
      howItWorks: howItWorks,
      footerEntity: footerEntity,
      leadgenHeader: leadgenHeader,
      ivr: ivr
    })
  });
};

export { CONSENT_PROFILE_FIELDS, FadeIn, FadeInBackwards, INPUT_TYPES, PROFILE_FIELDS_KEYS, StoriesWrapper, black, darkGreen, darkGrey, dataPixel, dropdownHover, getPixelLabelJSON, grey, greyscale4, linkBlue, mainGreen, minDesktopWidth, minMediumMobileWidth, minSmallMobileWidth, pixelKeys, sectionGrey, sectionYellow, statesList, transformData, warningRed };
